// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__MPYhh","content":"styles_content__2oaLi","selectAll":"styles_selectAll__2Vlsr"};